export default function modalDataSelector(func) {
  return func((state) => state.modalReducer);
}
